import React from 'react';
import { Alert } from 'reactstrap';
import moment from 'moment-timezone';
import utils from '../../../../lib/utils';
import Cdr from './Cdr';

const CdrAnalytics = ({ cdrAnalytics = [],onSelectRow }) => {
  let count = 0;
  const displayTimeZone = utils.getUserDisplayTimeZone();
  const timeZoneAbbr = moment().tz(displayTimeZone).format('z');
  const handleRowSelect = (row) => {
    onSelectRow(row);
  };

  const validCdrs = Array.isArray(cdrAnalytics) ? cdrAnalytics.filter(Boolean) : [];

  return (
    <div className="table-header-fixed">
      <table>
        <thead>
          <tr>
            {/* <th className="cursor-pointer">Source Port</th> */}
            <th className="cursor-pointer">Caller ID</th>
            <th className="cursor-pointer">Destination #</th>
            <th className="cursor-pointer">Type</th>
            <th className="cursor-pointer">Date</th>
            <th className="cursor-pointer">Time ({timeZoneAbbr})</th>
            <th className="cursor-pointer">Duration</th>
            <th className="cursor-pointer">MOS Score</th>
            <th />
          </tr>
        </thead>
        <tbody>
        {validCdrs && validCdrs.length ? (
            validCdrs.map((cdr, idx) => (
              <Cdr key={idx} cdr={cdr} index={idx} onRowSelect={handleRowSelect} />
            ))
          ) : (
            <tr>
              <td colSpan={8}>
                <Alert rowSpan={8} color="info">
                  No Logs Activity Found!
                </Alert>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default CdrAnalytics;
